import React from "react";
import { toTitleCase } from "../../utils/viewUtils";

interface ListItem {
  [key: string]: any;
}

interface GenericListViewProps {
  items: (ListItem | string)[];
  listTitle?: string; // Optional title for the list
}

const GenericListView: React.FC<GenericListViewProps> = ({
  items,
  listTitle,
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  const renderItem = (item: ListItem | string, index: number) => {
    if (typeof item === "string") {
      return (
        <li
          key={index}
          className="py-3 border-b border-gray-200 dark:border-gray-700"
        >
          <div className="flex">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-text-primary dark:text-text-primary-dark">
                {item}
              </p>
            </div>
          </div>
        </li>
      );
    }

    const entries = Object.entries(item);

    if (entries.length === 0) {
      return (
        <li
          key={index}
          className="py-3 border-b border-gray-200 dark:border-gray-700"
        >
          <div className="flex">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-text-primary dark:text-text-primary-dark">
                Empty object
              </p>
            </div>
          </div>
        </li>
      );
    }

    return (
      <li
        key={index}
        className="py-3 border-b border-gray-200 dark:border-gray-700"
      >
        <div className="flex flex-col gap-1">
          {entries.map(([key, value]) => {
            if (
              value === null ||
              value === undefined ||
              typeof value === "object"
            ) {
              return null;
            }

            return (
              <div key={key} className="flex">
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-text-primary dark:text-text-primary-dark">
                    <span className="font-medium">{toTitleCase(key)}:</span>{" "}
                    {String(value)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </li>
    );
  };

  return (
    <div className="w-full rounded-lg p-4">
      <ul>{items.map(renderItem)}</ul>
    </div>
  );
};

export default GenericListView;
